export default "__VITE_ASSET__BWEpcXlE__"